var boostAI_DefaultSortingValue={sorting:"Sorting",sorting_best_selling:"Best Selling",sorting_featured:"Featured",sorting_heading:"Sorting",sorting_manual:"Manual",sorting_relevance:"Relevance",sorting_created_ascending:"Created Ascending",sorting_created_descending:"Created Descending",sorting_date_ascending:"Date Ascending",sorting_date_descending:"Date Descending",sorting_published_descending:"Published Descending",sorting_published_ascending:"Published Ascending",sorting_price_ascending:"Price Ascending",sorting_price_descending:"Price Descending",sorting_sale_ascending:"% Off",sorting_sale_descending:"% Off, Low to High",sorting_title_ascending:"Title Ascending",sorting_title_descending:"Title Descending"};try{if("undefined"!=typeof boostPFSThemeConfig&&boostPFSThemeConfig.hasOwnProperty("label"))for(var key in boostPFSThemeConfig.label){if(boostPFSThemeConfig.label.hasOwnProperty(key)&&"string"==typeof boostPFSThemeConfig.label[key])-1!==(value=boostPFSThemeConfig.label[key].toLowerCase()).indexOf("translation missing")&&void 0!==boostAI_DefaultSortingValue[key]&&(boostPFSThemeConfig.label[key]=boostAI_DefaultSortingValue[key])}if("undefined"!=typeof bcSfFilterConfig&&bcSfFilterConfig.hasOwnProperty("label"))for(var key in bcSfFilterConfig.label){var value;if(bcSfFilterConfig.label.hasOwnProperty(key)&&"string"==typeof bcSfFilterConfig.label[key])-1!==(value=bcSfFilterConfig.label[key].toLowerCase()).indexOf("translation missing")&&void 0!==boostAI_DefaultSortingValue[key]&&(bcSfFilterConfig.label[key]=boostAI_DefaultSortingValue[key])}}catch(e){console.log("Patch defaultSortingValue error")}

var bcsffilter;
var ALL_PRODUCTS_EXTRA_DATA = [];
var ALL_YOPTO_REVIEW_DATA = [];

function getAllYoptoReviews() {
  var allReviews = [];
  var page = 1;
  var iterations = 0;
  var hasMore = true;
  while (iterations < 20 && hasMore) {
    var d = getYoptoReview(page);
    if (d.length > 0) {
      for (i=0; i<d.length; i++) {
        allReviews[d[i]['domain_key']] = {'score':d[i]['product_score'], 'c':d[i]['total_reviews']};
      }
      hasMore = true;
      page++;
    } else {
      hasMore = false; 
    }
    iterations++;
  }
  return allReviews;
}

function getYoptoReview(page) {
  var data = [];
  $.ajax({
    'url': 'https://api.yotpo.com/v1/apps/y9uszeSQdQgDGCCox0lFR8cFRTveAKoi8YSnoUmP/bottom_lines?count=100&page='+page,
    'dataType': 'json',
    'async': false,
    'success': function(ydata) {
      data = ydata.response.bottomlines;
    }
  });
  return data;
}

var maxMobileFilterButtonChecks = 10;
var checkMobileFilterButtonExist = null;
$(document).ready(function() {
  ALL_YOPTO_REVIEW_DATA = getAllYoptoReviews();
  $.ajax({
    'url':'//rawfitnessequipment.com.au/pages/product_data_feed',
    'dataType': 'script',
    'success': function(data) {
      /* init bcsffilter */
      bcsffilter = new BCSfFilter(); bcsffilter.init(); if(typeof bcSfFilterConfig != 'undefined' && typeof bcSfFilterConfig.general != 'undefined' && typeof bcSfFilterConfig.general.isInitFilter != 'undefined' && bcSfFilterConfig.general.isInitFilter === true){ bcsffilter.initFilter(); } bcsffilter.initSearchBox();
      
      checkMobileFilterButtonExist = setInterval(function() {
        if ($('#bc-sf-filter-tree-mobile-button').length && $('#bc-sf-filter-tree-mobile-button').is(':visible')) {
          $('#bc-sf-filter-tree-mobile-button').trigger('click');
          clearInterval(checkMobileFilterButtonExist);
        }
        maxMobileFilterButtonChecks--;
        if (maxMobileFilterButtonChecks < 0) {
          clearInterval(checkMobileFilterButtonExist);
        }
      }, 100);
    },
    'error': function () {
       bcsffilter = new BCSfFilter(); bcsffilter.init(); if(typeof bcSfFilterConfig != 'undefined' && typeof bcSfFilterConfig.general != 'undefined' && typeof bcSfFilterConfig.general.isInitFilter != 'undefined' && bcSfFilterConfig.general.isInitFilter === true){ bcsffilter.initFilter(); } bcsffilter.initSearchBox();
    }
  });
});